// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dhQnRSpdUW3PId {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
  text-align: center;
}
.dhQnRSpdUW3PId .t8lRrewRrrVlgx {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 18px;
  margin-bottom: var(--ds-space-0, 0);
}
.dhQnRSpdUW3PId .mDqbtUmkjvdbea {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
.dhQnRSpdUW3PId .XRdKV2oYYcOBJM {
  margin-bottom: var(--ds-space-200, 16px);
}
.dhQnRSpdUW3PId .XRdKV2oYYcOBJM .ud90JaawfWITTb {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.dhQnRSpdUW3PId .XRdKV2oYYcOBJM .ihuzYTDcTKXi2V,
.dhQnRSpdUW3PId .XRdKV2oYYcOBJM .lJlJdCu5vix4Ms {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.dhQnRSpdUW3PId .ivB2QrlA5k_ceO {
  margin-bottom: var(--ds-space-200, 16px);
}
.dhQnRSpdUW3PId .ivB2QrlA5k_ceO .iVDIAVpMhO6Iih {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.dhQnRSpdUW3PId .T2qjxSTS6cpN6k {
  display: grid;
  height: 70px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-0, 0) 15px;
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.dhQnRSpdUW3PId .T2qjxSTS6cpN6k p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  .dhQnRSpdUW3PId {
    width: 265px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCard": `dhQnRSpdUW3PId`,
	"name": `t8lRrewRrrVlgx`,
	"info": `mDqbtUmkjvdbea`,
	"priceContainer": `XRdKV2oYYcOBJM`,
	"price": `ud90JaawfWITTb`,
	"frequency": `ihuzYTDcTKXi2V`,
	"pricingVaries": `lJlJdCu5vix4Ms`,
	"ctaContainer": `ivB2QrlA5k_ceO`,
	"currentPlan": `iVDIAVpMhO6Iih`,
	"enterpriseFooter": `T2qjxSTS6cpN6k`
};
export default ___CSS_LOADER_EXPORT___;
